import React, { useEffect, useRef, useState } from 'react';
import Wrapper from "./Wrapper";
import logo from '../../assets/Images/logo.svg';
import { Link } from 'react-router-dom';
import HamburgerMenu from "./HamburgerMenu"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Account from "../user/Account";

const Header = () => {
    const headerRef = useRef(null);
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (headerRef.current) {
                const stickyThreshold = headerRef.current.offsetHeight;
                setIsSticky(window.scrollY > stickyThreshold);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navItems = [
        { label: 'بلاگ', to: '/fa/blog/' },
        { label: 'دوره‌ها', to: '/fa/course/' },
    ];

    return (
        <>
            <header
                ref={headerRef}
                className={`w-full py-1 z-50 transition-all min-h-[80px] backdrop-blur-sm duration-300 border-b-4 border-gray-200 ${
                    isSticky ? 'fixed top-0 left-0 bg-white/70 shadow-md' : 'relative'
                }`}>
                <Wrapper className="flex relative items-center justify-between">
                    <Link
                        to="/"
                        className="absolute left-1/2 top-1/2  lg:top-0 lg:translate-y-0 -translate-x-1/2 flex items-center gap-x-1 md:static md:translate-x-0 md:mx-0 md:gap-x-2 order-2 md:order-1">
                        <img src={logo} alt="Logo" className="h-14 rounded-sm" />
                        <span className="text-2xl font-bold text-light-primary">کدپرو</span>
                    </Link>

                    {/* Hamburger menu: Right on small screens */}
                    <HamburgerMenu
                        navItems={navItems}
                        className="inline-block order-1 md:order-2"
                    />

                    {/* Logo: Centered on mobile, start on md+ */}
                    <Account className='order-3' />

                </Wrapper>
            </header>
            {/* Push the content down when sticky */}
            <div className={`${isSticky ? 'h-[72px]' : ''}`}></div>
        </>
    );
};

export default Header;
